const INSIDE_RADIX_SELECT_FOR_ENTER =
  '[data-radix-popper-content-wrapper], [role="listbox"], [data-radix-select-viewport], [data-radix-select-content]';

export const shouldSubmitEmptyOnEnterForNextChoice = (
  target: EventTarget | null,
): boolean => {
  if (!(target instanceof Element)) return true;
  if (target.closest(INSIDE_RADIX_SELECT_FOR_ENTER) != null) return false;
  if (target.closest('[role="option"]') != null) return false;
  return true;
};
